import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";
import { logout } from "../../lib/auth";

interface Props {
  open: boolean;
  onClose: () => void;
}

interface MoreEntry {
  to?: string;
  labelKey: string;
  defaultLabel: string;
  action?: "logout";
}

const ENTRIES: MoreEntry[] = [
  { to: "/dividends", labelKey: "nav.dividends", defaultLabel: "Dividenden" },
  { to: "/cashflow", labelKey: "nav.cashflow", defaultLabel: "Cashflow" },
  { to: "/insurance", labelKey: "nav.insurance", defaultLabel: "Versicherungen" },
  { to: "/realestate", labelKey: "nav.realestate", defaultLabel: "Immobilien" },
  { to: "/pension", labelKey: "nav.pension", defaultLabel: "Rente / FIRE" },
  { to: "/budget", labelKey: "nav.budget", defaultLabel: "Budget" },
  { to: "/accounts", labelKey: "nav.accounts", defaultLabel: "Konten" },
  { to: "/import", labelKey: "nav.import", defaultLabel: "Import" },
  { to: "/settings", labelKey: "nav.settings", defaultLabel: "Einstellungen" },
  { labelKey: "nav.logout", defaultLabel: "Abmelden", action: "logout" },
];

export function MobileMoreSheet({ open, onClose }: Props) {
  const { t } = useTranslation();

  const handleLogout = () => {
    logout();
    onClose();
    window.location.href = "/login";
  };

  return (
    <>
      <div
        className={`fixed inset-0 z-40 transition-opacity md:hidden ${
          open ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none"
        }`}
        style={{ background: "rgba(0,0,0,0.5)" }}
        onClick={onClose}
        onKeyDown={(e) => {
          if (e.key === "Escape") onClose();
        }}
        role="presentation"
        aria-hidden={!open}
      />
      <div
        className={`fixed left-0 right-0 bottom-0 z-50 rounded-t-2xl transition-transform md:hidden ${
          open ? "translate-y-0" : "translate-y-full"
        }`}
        style={{
          background: "var(--card)",
          borderTop: "1px solid var(--border)",
          maxHeight: "70vh",
          paddingBottom: "env(safe-area-inset-bottom)",
        }}
        aria-label={t("nav.more", { defaultValue: "Mehr" })}
      >
        <div className="flex justify-center pt-2 pb-1">
          <div
            className="w-12 h-1 rounded-full"
            style={{ background: "var(--border)" }}
            aria-hidden="true"
          />
        </div>
        <nav className="overflow-y-auto px-4 pb-4" style={{ maxHeight: "calc(70vh - 24px)" }}>
          {ENTRIES.map((e) =>
            e.action === "logout" ? (
              <button
                key="logout"
                type="button"
                onClick={handleLogout}
                className="w-full text-left py-3 border-b text-sm font-medium active:opacity-60"
                style={{ borderColor: "var(--border)", color: "var(--neg)" }}
              >
                {t(e.labelKey, { defaultValue: e.defaultLabel })}
              </button>
            ) : (
              <NavLink
                key={e.to}
                to={e.to ?? "/"}
                onClick={onClose}
                className="block py-3 border-b text-sm font-medium active:opacity-60"
                style={{ borderColor: "var(--border)", color: "var(--text)" }}
              >
                {t(e.labelKey, { defaultValue: e.defaultLabel })}
              </NavLink>
            ),
          )}
        </nav>
      </div>
    </>
  );
}
